export default __webpack_public_path__ + "static/media/ep26.67ccd304.jpeg";